import es from './translations/es'
import en from './translations/en'
import fr from './translations/fr'
import ca from './translations/ca'


export default {
  es,
  en,
  fr,
  ca
};



// WEBPACK FOOTER //
// ./src/_locale/index.js